import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  OnInit,
  OnDestroy,
  AfterViewInit
} from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Directive({
  selector: '[appDebounceDropdown]'
})
export class DebounceDropdownDirective implements OnInit, OnDestroy, AfterViewInit {
  
  @Input() debounceTime = 300;
  @Output() debouncedFilter = new EventEmitter<string>();
  
  private inputSubscription?: Subscription;
  private mutationObserver?: MutationObserver;
  private clickSubscription?: Subscription;

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.clickSubscription = fromEvent(this.elementRef.nativeElement, 'click')
      .subscribe(() => {
        setTimeout(() => this.tryAttachToFilter(), 100);
      });

    // Also try immediately in case it's already open
    setTimeout(() => this.tryAttachToFilter(), 100);
  }

  private tryAttachToFilter(): boolean {
    const overlayPanel = document.querySelector('.p-dropdown-panel') as HTMLElement;
    
    if (!overlayPanel) {
      return false;
    }

    const filterInput = overlayPanel.querySelector('input.p-dropdown-filter') as HTMLInputElement;
  
    if (!filterInput) {
      return false;
    }
  
    if ((filterInput as any).__debounce_attached) {
      return true;
    }
  
    (filterInput as any).__debounce_attached = true;
  
  
    this.inputSubscription?.unsubscribe();
  
    this.inputSubscription = fromEvent(filterInput, 'input')
      .pipe(
        map((e: any) => e.target.value),
        debounceTime(this.debounceTime),
        distinctUntilChanged()
      )
      .subscribe((value) => {
        this.debouncedFilter.emit(value);
      });
  
    return true;
  }

  ngOnDestroy() {
    this.inputSubscription?.unsubscribe();
    this.clickSubscription?.unsubscribe();
    this.mutationObserver?.disconnect();
  }
}